import { render, staticRenderFns } from "./client_spaces.vue?vue&type=template&id=242e02ea&scoped=true"
import script from "./client_spaces.vue?vue&type=script&lang=js"
export * from "./client_spaces.vue?vue&type=script&lang=js"
import style0 from "./client_spaces.vue?vue&type=style&index=0&id=242e02ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242e02ea",
  null
  
)

export default component.exports